import { SettingsParser } from "../../settings-parser";
import { IsolinePlotSettings } from "../../../settings/view-objects/plot/isoline-plot-settings";
import { getSizeSettings } from "../../../../utils/get-size-settings";
import { ColorConverter, ObjectCreator } from "../../../../../../../web-graphics";

export class IsolinePlotSettingsParser extends SettingsParser {
  constructor() {
    super();
    this.parsedFieldNames = ["id", "y", "color", "updateBorder"];
  }

  static createSettings(settings, defaultSettings) {
    if (settings === undefined) {
      return undefined;
    }
    let parsedColorText = ObjectCreator.merge(settings.color, defaultSettings?.color);
    let colorParsingResult = ColorConverter.convertToWebglRgba(parsedColorText);
    let parsedSettings = {
      id: settings.id,
      y: getSizeSettings(settings.y, 0, 0),
      color: colorParsingResult.value,
      updateBorder: ObjectCreator.merge(settings.updateBorder, defaultSettings?.updateBorder)
    };
    return parsedSettings;
  }

  parse(settings, defaultSettings) {
    let parsedSettings = IsolinePlotSettingsParser.createSettings(settings, defaultSettings);
    if (parsedSettings === undefined) {
      return undefined;
    }
    SettingsParser.parseRestFields(settings, defaultSettings, this.parsedFieldNames, parsedSettings);
    return new IsolinePlotSettings(parsedSettings);
  }
}
